const configuredPersonalApp: unknown = (
  import.meta.env as Readonly<Record<string, unknown>>
)["VITE_PERSONAL_APP"];

export const personalApp =
  typeof configuredPersonalApp === "string" &&
  configuredPersonalApp.toLowerCase() === "true";

export const authenticationScopeHeaders: Readonly<Record<string, string>> =
  personalApp ? { "x-cem-auth-scope": "personal" } : {};

export const csrfCookieName = personalApp ? "cem_personal_csrf" : "cem_csrf";

export const sessionIdentifiers = (personal: boolean) => ({
  storageKey: personal ? "cem_personal_client_instance" : "cem_client_instance",
  channelName: personal ? "cem_personal_auth_pages" : "cem_auth_pages",
});

export const currentSessionIdentifiers = sessionIdentifiers(personalApp);
